module.exports = __webpack_public_path__ + "static/media/em-109.ddaed919.png";